import { useState } from 'react'

import { cn } from '@/utils/tw-helpers'
import { QuestionProps } from './types'

interface TextQuestionProps extends QuestionProps {
  defaultValue?: string
  labelClassName?: string
}

export const TextQuestion = ({
  question,
  defaultValue,
  labelClassName,
  onValueChange,
}: TextQuestionProps): JSX.Element => {
  const [answer, setAnswer] = useState({
    value: defaultValue || '',
  })

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setAnswer({
      value: e.target.value,
    })
    onValueChange?.({
      value: e.target.value,
    })
  }

  return (
    <section className="text-question-container">
      <h4
        className={cn(
          'mb-4 text-[13px] font-bold text-secondary-20',
          labelClassName
        )}
      >
        {question.question}
        {question.required && <span className="text-danger"> ※</span>}
      </h4>

      <textarea
        value={answer.value}
        className="w-full rounded-md border-2 border-border/20 p-3"
        onChange={handleChange}
        rows={4}
      />
    </section>
  )
}
